// General methods that often need throughout projects.
// Trying to keep it DRY

export const exists = {
    methods: {
        exists(item) {
            return typeof item !== 'undefined' && item !== null;
        },

        arrayExists(item) {
            return Array.isArray(item) && item.length > 0;
        },

        simpleArraysAreEqual(arr1, arr2) {
            if (arr1.length !== arr2.length) {
                return false;
            }
            for (let i = 0; i < arr1.length; i++) {
                if (arr1[i] !== arr2[i]) {
                    return false;
                }
            }
            return true;
        },
    },
};
